import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0eb9b5b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nps-bar" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nb-bar nb-background" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "nb-bar nb-nps",
      style: _normalizeStyle({
                left: _ctx.deltaPositionRelative + '%',
                width: _ctx.deltaWidthPercent + '%',
                background: _ctx.npsColor,
            })
    }, null, 4),
    _createElementVNode("div", {
      class: "nb-average",
      style: _normalizeStyle({ left: _ctx.middlePercent + '%' })
    }, null, 4)
  ]))
}